import * as React from 'react';
import { Badge } from '@emorg-prd/standard-react';
import { WorkflowState } from '../../models/enums/WorkflowState';

interface WorkflowStateBadgeProps {
	workflowState: WorkflowState;
	fullWidth?: boolean;
}

export default class WorkflowStateBadge extends React.Component<WorkflowStateBadgeProps> { 
	type: "em-c-badge--positive" | "em-c-badge--caution" | "em-c-badge--negative";

	constructor(props) {
		super(props);
		
		switch (this.props.workflowState?.value) {
		case WorkflowState.Submitted?.value:
		case WorkflowState.PendingDeletion?.value:
		case WorkflowState.Draft?.value:
		case WorkflowState.AwaitingImplementation?.value:
		case WorkflowState.Review?.value:
		case WorkflowState.AwaitingDeletion?.value:
			this.type = 'em-c-badge--caution';
			break;
		case WorkflowState.Approved?.value:
		case WorkflowState.Completed?.value:
			this.type = 'em-c-badge--positive';
			break;
		case WorkflowState.Rejected?.value:
		case WorkflowState.Error?.value:
		case WorkflowState.Deleted?.value:
		case WorkflowState.Cancelled?.value:
		case WorkflowState.ImplementationFailed?.value:
		case WorkflowState.Expired?.value:
			this.type = 'em-c-badge--negative';
			break;
		default:
			break;
		}
	}

	render() {
		return (
			<Badge
				optionalClass={`em-u-max-width-10 ${this.props.fullWidth && 'em-u-width-100' || ''}`}
				type={this.type}
				text={this.props.workflowState?.name}
			/>
		);
	}
}